<template>
	<div class="main-content">
		<div class="center-body">
			<Nav></Nav>
			<div class="row ph-tp" style="margin-top: 20px;font-size: 20px;font-weight: 600;">
				经典案例
			</div>
			<baidu-map class="map" :center="center" map:zoom="zoom" @ready="handler" ></baidu-map>
			<div class="row ph-tp" style="font-size: 20px;font-weight: 600;margin-top: 40px;">
				在线咨询
			</div>
			<div class="row" style="padding: 5px 0px;font-size: 14px;color: #999;">
				留下您的联系方式 ，方便我们联系您 ，为您提供更好的服务！
			</div>
			 <Form :model="formItem" :label-width="80" style="margin-top: 15px;padding: 10px 0px;">
		        <FormItem label="物料名称">
		            <Input v-model="formItem.input1"></Input>
		        </FormItem>
		        <FormItem label="应用行业">
		            <Input v-model="formItem.input2"></Input>
		        </FormItem>
		        <FormItem label="公司名称">
		            <Input v-model="formItem.input3"></Input>
		        </FormItem>
		        <FormItem label="您的姓名">
		            <Input v-model="formItem.input4"></Input>
		        </FormItem>
		        <FormItem label="联系电话">
		            <Input v-model="formItem.input5"></Input>
		        </FormItem>
		        <FormItem label="电子邮件">
		            <Input v-model="formItem.input6"></Input>
		        </FormItem>
		       	<FormItem>
		            <Button type="primary" @click="commit">确认</Button>
		            <!--<Button style="margin-left: 8px">Cancel</Button>-->
		        </FormItem>
		        
		    </Form>
		</div>	
	</div>
</template>

<script>
	import Nav from './nav.vue'
	export default {
		name: 'App',
		components: {
		    Nav
		},
		data() {
			return {
				center: {lng: 109.49926175379778, lat: 36.60449676862417},
      			zoom: 5,
      			formItem:{},
				url: require('./1.png')
			}
		},
		methods: {
			handler ({BMap, map}) {
		      	var icon1 = new BMap.Icon(this.url,new BMap.Size(24,24),
		      	{
　　　　　　　　　　imageSize: new BMap.Size(24,24), // 引用图片实际大小
　　　　　　　　　　imageOffset:new BMap.Size(0,0)  // 图片相对视窗的偏移
　　　　　　　　});
				map.centerAndZoom(new BMap.Point(109.49926,36.60449), 5);
				
				map.disableDragging(); 
				map.disableDoubleClickZoom()
				var data_info = [[108.4992,34.40449,"西安邓家村污水处理厂<br>延安炼油厂<br>长庆石化<br>大唐太原第二电厂<br>陕西榆林醋酸<br>陕北乾元能源化工",17],
								 [104.5992,35.20449,"兰州炼油厂<br>兰州七里河污水处理厂<br>兰州石化污水处理厂<br>定西污水厂",4],
								 [120.012222,29.612345,"宁波中华纸业<br>宁波岩东污水处理厂<br>镇海炼化<br>杭州半山天然气发电<br>浙江三星石化<br>东阳市第二自来水厂",78],
								 [121.712222,31.412345,"闵行自来水二厂<br>上海白龙港污水处理厂<br>上海临港新城污水处理厂<br>上海上钢一厂<br>高桥石化",29],
								 [119.212222,33.412345,"苏州工业园区污水处理厂<br>无锡荣成纸业有限公司<br>扬子石化水厂<br>南通醋酸纤维<br>太仓市应急水源地",41],
								 [117.212222,31.412345,"安徽亳州污水处理厂<br>安徽六安污水处理厂<br>安徽涡阳污水处理厂<br>合肥龚响堂污水处理厂<br>中安联合",5],
							 	 [116.511788,39.848988,"北京高碑店污水处理厂<br>北京燕山石化<br>北京卢沟桥污水处理厂<br>北京首钢<br>北京通州水厂",10],
								 [113.266887,23.133306,"深圳滨河污水处理厂厂<br>东莞九龙纸业<br>广东南海第二自来水厂<br>台山电厂<br>东莞污泥干化",36],
								 [108.296265,23.228559,"柳州污水处理厂<br>桂林污水处理厂<br>南宁郎东污水处理厂<br>广西钦州港水厂<br>桂林瓦窑",5],
								 [114.530399,38.037707,"唐山北郊污水处理厂<br>邯郸钢铁<br>保定钞票纸厂<br>唐山曹妃甸<br>河北冀腾纸业<br>唐县洁源垃圾处置",17],
								[113.753094,34.767052,"郑州污水处理厂<br>洛阳石化<br>民权电厂<br>河南神火发电项目<br>河南大唐巩义水岛",18],
								[126.661998,45.742253,"大庆油田<br>英年马利食品<br>黑龙江某热电",3],
								[114.341552,30.546222,"武汉二郎庙污水处理厂<br>武汉铁路局汉口水电担<br>襄樊市渔梁洲污水处理厂<br>夷陵区污水处理厂",4],
								[112.982951,28.116007,"长沙第一污水处理厂",1],
								[125.325802,43.896942,"延边石岘白麓纸业<br>吉林污水处理厂<br>吉林石化<br>长春热电厂<br>辽源电厂",17],
								[115.816587,28.6372347,"蓝星星火有机硅<br>江西晨鸣纸业<br>赣州水务集团水厂应急投加",3],
								[123.435093,41.836743,"鞍山钢铁厂<br>锦州炼油厂<br>辽阳石化<br>盘锦污水处理厂<br>康平电厂<br>抚顺矿业",18],
								[111.670801,40.818311,"呼和浩特炼油厂<br>包头黄河水厂<br>丰镇电厂<br>呼和浩特公主府污水厂<br>内蒙大唐国际克旗煤制天然气",10],
								[106.278179,38.46637,"宁夏上海庙<br>宁东能源化工基地供水<br>宁煤水处理",3],
								[117.020725,36.670201,"曲阜污水处理厂<br>日照森博纸业<br>青岛石化<br>焦作电厂<br>国电泰安热电“水岛”",17],
								[112.549248,37.857014,"太原东山项目<br>山西永济热电联产工程<br>山西潞安",3],
								[104.076452,30.651696,"成都第二污水处理厂<br>成都第六水厂  <br>成都二水厂<br>四川石化<br>营山县城饮用水源工程",10],
								[117.201538,39.0852947,"天津钢铁污水处理厂<br>天津曹妃甸<br>天津耀龙纸业<br>诺维信（中国）生物技术<br>天津开发区一汽大众",15],
								[114.171203,22.2774687,"香港SKW/YSW<br>香港青山火电厂",5],
								[88.36985,41.07997,"独山子炼油厂<br>克拉玛依油田<br>独山子炼油厂<br>新疆马利食品<br>新疆克拉玛依水岛电厂",6],
								[102.709372,25.046432,"玉溪污水处理厂",1],
								[106.550464,29.563761,"万州项目",1],

								];
				
				for(var i=0;i<data_info.length;i++){
					var marker = new BMap.Marker(new BMap.Point(data_info[i][0],data_info[i][1]),{icon:icon1});  // 创建标注
					var content = data_info[i][2];
					var opts = {
							width : 250,     // 信息窗口宽度
							enableMessage:true//设置允许信息窗发送短息
						};
					opts.title= "累计"+data_info[i][3]+"个<br>经典案例如下："
					map.addOverlay(marker);               // 将标注添加到地图中
					addClickHandler(content,marker,opts);
//					marker.setAnimation(BMAP_ANIMATION_BOUNCE)
					
				}
				function addClickHandler(content,marker,opts){
					marker.addEventListener("mouseover",function(e){
						openInfo(content,e,opts)}
					);
					
				}
				
				function openInfo(content,e,opts){
					var p = e.target;
					var point = new BMap.Point(p.getPosition().lng, p.getPosition().lat);
					 // 创建信息窗口对象 
					var infoWindow = new BMap.InfoWindow(content,opts); 
					map.openInfoWindow(infoWindow,point); //开启信息窗口
				}
				
		    },
			commit(){
				var self = this
				var formData={}
				formData = {
					'物料名称':self.formItem.input1,
					'应用行业':self.formItem.input2,
					'公司名称':self.formItem.input3,
					'姓名':self.formItem.input4,
					'联系电话':self.formItem.input5,
					'电子邮件':self.formItem.input6,
				}
				this.$api.api.commit(JSON.stringify(formData)).then(function(response) {
					if(response.data.code == 200) {
						self.$toast('提交成功');
					} else {
						self.$toast(response.data.msg);
					}

				})
			}
		},
		mounted() {

		}
	}
</script>

<style scoped>
	.main-content {
		min-height: 100%;
		width: 100%;
		display: block;
		position: absolute;
		background: #FFF;
	}
	
	
	@media screen and (max-width: 980px) {
	    .center-body{	    	
	    	width: 100%;
	    	padding: 0px 10px;	    	
	    }
	    .main-nav{
	    	display: none;
	    }
	    .map{
	    	height:400px;
	    	width: 100%;
	    	margin-top: 10px;
	    }
	   
	}
	@media screen and (min-width: 980px) {
	    .center-body{	    	
	    	width: 980px;
	    	margin: 0 auto;
	    	padding-bottom: 120px;
	    }
	    .nav-title{
	    	font-size: 30px;
	    	height: 60px;
	    	padding-top: 10px;
	    	width: 160px;
	    	text-align: center;
	    	border-bottom: 1px solid #dcdee2;
	    	flex: none;
	    	
	    }
	    .nav-right{	    	
	    	height: 60px;
	    	border-bottom: 1px solid #dcdee2;
	    	
	    }
	    .ivu-menu-item{
	    	width: 120px;
	    	text-align: center;
	    }
	    .map{
	    	height:650px;
	    	width: 100%;
	    	margin-top: 10px;
	    }
	  
	}
</style>